import React from 'react';
import './styles.css';

const MobileHobbies = ({ isDarkMode }) => {
    const hobbies = [
        {
            title: "Formula 1",
            description: "Going in circles at 200mph and calling it a sport",
            icon: "🏎️"
        },
        {
            title: "Aviation",
            description: "Defying gravity because walking is too mainstream",
            icon: "✈️"
        },
        {
            title: "Watching Fireship (on 2x)",
            description: "Learning things I'll never use at incomprehensible speeds",
            icon: "🔥"
        },
        {
            title: "Video gaming",
            description: "My fictional characters have better life stories than I do",
            icon: "🎮"
        },
        {
            title: "Documentaries",
            description: "Pretending I'm intellectual while eating nachos in pajamas",
            icon: "🎬"
        },
        {
            title: "Writing parody songs",
            description: "Butchering classics one misplaced rhyme at a time",
            icon: "🎤"
        }
    ];

    return (
        <div className="mobile-page">
            <div className="mobile-content-wrapper">
                <div className="mobile-page-header">
                    <h1 className="mobile-page-header-title">Hobbies</h1>
                    <div className="mobile-page-header-accent"></div>
                </div>

                <div className="mobile-content-section">
                    {hobbies.map((hobby, index) => (
                        <div key={index} className="mobile-card mobile-hobby-card">
                            <div className="mobile-hobby-icon">{hobby.icon}</div>
                            <div className="mobile-hobby-content">
                                <h3 className="mobile-card-title">{hobby.title}</h3>
                                <p className="mobile-card-description">{hobby.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MobileHobbies;
